// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueTwoDatePicker.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Two datetime picker component
 */
!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var DateTimePicker = require('share/components/controls/DateTime/Izenda.DateTimePicker');
  var Constants = require('logic/data/Izenda.ReportDesignerConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { isNil } = require('lodash/fp');

  var OperatorValueTwoDatePicker = React.createClass({
    propTypes: {
      filterInfo: React.PropTypes.object.isRequired
    },

    /**
     * When change value of datepicker
     * @param  {string} newVal
     */
    onChangeLessThanDate: function(newVal) {
      var greaterDate = isNil(this.props.filterInfo.value) ? null : this.props.filterInfo.value[1];
      var value = [newVal, greaterDate];
      this.props.onChange(value);
    },

    /**
     * When change value of datepicker
     * @param  {string} newVal
     */
    onChangeGreaterDate: function(newVal) {
      var lessThanDate = isNil(this.props.filterInfo.value) ? null : this.props.filterInfo.value[0];
      var value = [lessThanDate, newVal];
      this.props.onChange(value);
    },

    render: function() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      var lessThanDateString = filterInfo.value && filterInfo.value[0];
      var greaterDateString = filterInfo.value && filterInfo.value[1];
      return (
        <GridLayout className='izenda-FilterRangeInput'>
          <DateTimePicker
            onChange={this.onChangeLessThanDate}
            value={lessThanDateString}
            disabled={props.disabled}
            time={props.time}
            calendar={props.calendar}
            renderInContainer={props.renderInContainer}
          />

          <div className='izenda-Filter-BetweenIcon'>
            <span className='icon-big-arr' />
          </div>

          <DateTimePicker
            onChange={this.onChangeGreaterDate}
            value={greaterDateString}
            disabled={props.disabled}
            time={props.time}
            calendar={props.calendar}
            renderInContainer={props.renderInContainer}
          />
        </GridLayout>
      );
    }
  });

  module.exports = OperatorValueTwoDatePicker;
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueTwoDatePicker.jsx